import React, { createContext, useContext } from "react";
import HyroTable from "@hyro-components/hyro-table/HyroTable";
import { BENCHMARKS_TABLE_COLUMNS, BENCHMARK_TYPES } from "./AnalyticsSettings.consts";
import { getBenchmarkFormat, getOverrideTypeColumn } from "./AnalyticsSettings.utils";
import EditableMetricCell from "./EditableMetricCell";

const BenchmarkUpdateContext = createContext(null);

const BenchmarkEditCell = (params) => {
  const onBenchmarkUpdate = useContext(BenchmarkUpdateContext);
  const { max, validationError, unit } = getBenchmarkFormat(params.row.id);
  return (
    <EditableMetricCell
      {...params}
      max={max}
      errorMessage={validationError}
      helperText={`Default ${params.row.defaultBenchmark}${unit}`}
      onCommit={(num) => onBenchmarkUpdate(params.row.id, num)}
    />
  );
};

const benchmarkColumn = {
  ...BENCHMARKS_TABLE_COLUMNS[1],
  editable: true,
  renderEditCell: (params) => <BenchmarkEditCell {...params} />,
  renderCell: ({ row, value }) => `${value} ${row.unit}`
};

const typeColumn = getOverrideTypeColumn(BENCHMARKS_TABLE_COLUMNS[2]);

const columns = [BENCHMARKS_TABLE_COLUMNS[0], benchmarkColumn, typeColumn];

const formatRows = (benchmarks) =>
  benchmarks.map((b) => {
    const { toDisplay, unit } = getBenchmarkFormat(b.metricId);
    return {
      id: b.metricId,
      metricName: b.metricName,
      benchmark: toDisplay(b.benchmark),
      defaultBenchmark: toDisplay(b.defaultBenchmark),
      unit,
      type: b.isOverridden ? BENCHMARK_TYPES.CUSTOM : BENCHMARK_TYPES.DEFAULT,
      isOverridden: b.isOverridden
    };
  });

const BenchmarksTable = ({ benchmarks, loading, onBenchmarkUpdate }) => {
  const rows = benchmarks ? formatRows(benchmarks) : [];

  return (
    <BenchmarkUpdateContext.Provider value={onBenchmarkUpdate}>
      <HyroTable
        columns={columns}
        rows={rows}
        loading={loading}
        disableColumnSorting
        testId="benchmarks"
        minHeight={1}
        dataGridProps={{ autoHeight: true }}
      />
    </BenchmarkUpdateContext.Provider>
  );
};

export default BenchmarksTable;
